module.exports = __webpack_public_path__ + "img/code.1a19dc3e.png";